<template>
    <transition name="slide">
        <div v-if="$parent.uiStates.activityView" class="dashboard-activity ">
            <transition name="vue-table-loader">
                <div class="vue-details-loader"v-if="uiStates.showLoading"><span class="fa fa-cog fa-spin fa-1x"></span></div>
            </transition>
            <div class="heading">
                <div class="title">User Activity</div>
                <a @click.prevent="closeActivity()" class="close-activity"><i class="fa fa-times"></i></a>
            </div>
            <div class="activity-listing">
                <table class="table table-middle table-minimal">
                    <thead>
                        <tr>
                            <th scope="col">Type</th>
                            <th scope="col">Time</th>
                            <th scope="col">User</th>
                            <th scope="col" class="text-right">Action</th>
                        </tr>
                    </thead>
                    <tr v-for="(activity, index) in userActivity" :key="index">
                        <td>
                            <div class="activity-name">{{activity.type}}</div>
                            <div class="activity-time">{{activity.action}}</div>
                        </td>
                        <td>
                            <div class="activity-name">{{activity.updatedDate}}</div>
                            <div class="activity-time">{{activity.updatedTime}}</div>
                        </td>
                        <td>
                            <div class="activity-name">
                                <a :href="'/users/' + activity.userId + '/edit'">{{activity.userName}}</a>
                            </div>
                        </td>
                        <td class="text-right">
                            <a :class="{'disabled': activity.action == 'Destroy'}" v-if="activity.type == 'attribute'" :href="'/attributes/'+ activity.contentId +'/edit'" class="btn btn-primary">View</a>
                            <a :class="{'disabled': activity.action == 'Destroy'}" v-if="activity.type == 'product'" :href="'/products/'+ activity.contentId +'/edit'" class="btn btn-primary">View</a>
                            <a :class="{'disabled': activity.action == 'Destroy'}" v-if="activity.type == 'attribute set'" :href="'/attribute_sets/'+ activity.contentId +'/edit'" class="btn btn-primary">View</a>
                            <a :class="{'disabled': activity.action == 'Destroy'}" v-if="activity.type == 'option set'" :href="'/option_sets/'+ activity.contentId +'/edit'" class="btn btn-primary">View</a>
                            <a :class="{'disabled': activity.action == 'Destroy'}" v-if="activity.type == 'option'" :href="'/options/'+ activity.contentId +'/edit'" class="btn btn-primary">View</a>
                            <a :class="{'disabled': activity.action == 'Destroy'}" v-if="activity.type == 'user'" :href="'/users/'+ activity.contentId +'/edit'" class="btn btn-primary">View</a>
                            <a :class="{'disabled': activity.action == 'Destroy'}" v-if="activity.type == 'role'" :href="'/roles/'+ activity.contentId +'/edit'" class="btn btn-primary">View</a>
                            <a :class="{'disabled': activity.action == 'Destroy'}" v-if="activity.type == 'categories'" :href="'/categories/'+ activity.contentId +'/edit'" class="btn btn-primary">View</a>
                        </td>
                    </tr>
                </table>
            </div>
        </div>
    </transition>
</template>
<script type="text/javascript">
    var base_url = window.location.protocol + "//" + window.location.host

    import Vue from 'vue';
    import VueEvents from 'vue-events'
    import axios from 'axios'
    import moment from 'moment';
    import BigValueWidget from './widgets/big-value-widget.vue';
    import WidgetChart from './widgets/widget-chart.vue';
    import UserActivity from './widgets/user-activity.vue';
    import draggable from 'vuedraggable'

    Vue.use(VueEvents)

    export default {
        name: 'dashboard-activity-view',
        props: [],
        components:{
            BigValueWidget,
            WidgetChart,
            UserActivity,
            draggable
        },
        data() {
            return {
                uiStates: {
                    showLoading: true,
                },
                userActivity: [],
                defaultResultsAmount: 20,
            }
        },
        mounted() {
            this.getUserActivity();
        },
        methods: {
            getUserActivity: function(){
                axios.get(base_url+'/pimapi/dashboards/'+this.defaultResultsAmount+'/pimActivity', {

                })
                .then(function(response) {
                    this.userActivity = response.data;
                    this.uiStates.showLoading = false;
                }.bind(this))
                .catch(function(error) {
                }.bind(this));
            },
            closeActivity: function(){
                this.$parent.uiStates.activityView = false;
            },
        },
    };
</script>

<style scoped="" lang="scss">
.vue-details-loader{
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    color: #25618f;
    background: white;
    z-index: 12;
    text-align: center;
    padding: 196px 10px;
}
.slide-enter-active,
.slide-leave-active {
    transition: all 0.3s;
}
.slide-enter,
.slide-leave-to {
    opacity: 0;
    transform: translateX(684px);
    right: -600px;
}
.dashboard-activity{
    position: fixed;
    padding: 105px 0 20px 0;
    top:0px;
    right: 0px;
    z-index: 2;
    bottom:0px;
    background: #FFFFFF;
    box-shadow: 0 0 8px 1px rgba(0, 0, 0, 0.2);
    width: 600px;
    .heading{
        position: relative;
        border-bottom: 1px solid #dee0e1;
        margin-bottom: -1px;
        margin-left: 20px;
        margin-right: 20px;
        padding: 0px 0px 30px 0px;
        background: -moz-linear-gradient(top,  rgba(255,255,255,1) 0%, rgba(255,255,255,1) 60%, rgba(255,255,255,0) 100%);
        background: -webkit-linear-gradient(top,  rgba(255,255,255,1) 0%,rgba(255,255,255,1) 60%,rgba(255,255,255,0) 100%);
        background: linear-gradient(to bottom,  rgba(255,255,255,1) 0%,rgba(255,255,255,1) 60%,rgba(255,255,255,0) 100%);
        filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ffffff', endColorstr='#00ffffff',GradientType=0 );
        .title{
            padding-top: 20px;
            font-size: 18px;
            color: #1F2529;
            text-align: left;
        }
        .close-activity{
            position: absolute;
            top:15px;
            right:23px;
            font-size: 20px;
            color: #576670;
        }
    }
    .activity-listing{
        position: relative;
        height: 80vh;
        padding: 0px 16px 12px 20px;
        overflow-y: auto;
        overflow-x: hidden;
        &::-webkit-scrollbar {
            width: 4px;
        }
        &::-webkit-scrollbar-track {
            background: #DEE0E1;
            position: absolute;
            top: 0px;
            bottom: 0px;
            right: 0px;
            border-radius:5px;
        }
        &::-webkit-scrollbar-thumb {
            background: #25628F;
            border-radius:5px;
        }
        &::-webkit-scrollbar-thumb:hover {
            background: #25628F;
        }
    }
}
.activity-name{
    font-weight: 800;
    font-size: 12px;
    color: #4A4A4A;
    letter-spacing: 0;
    text-transform: capitalize;
}
.activity-time{
    font-size: 12px;
    color: #807e7e;
    letter-spacing: 0;
    font-weight: 400;
}
</style>
